// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.commission_border{border-color:#d9d9d9 !important}`, "",{"version":3,"sources":["webpack://./src/app/pages/Transfer/components/TransferDomestic/index.scss"],"names":[],"mappings":"AACA,mBACI,+BAAA","sourcesContent":["\r\n.commission_border {\r\n    border-color: #d9d9d9 !important;\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
